import { trans } from '../_providers/Translation'

export function getReservationState(activityStatus) {
    switch (activityStatus) {
        case 'active':
            return {
                color: '#28a745',
                name: trans('labels.reservation-status.active')
            }
        case 'completed':
            return {
                color: '#3a52b6',
                name: trans('labels.reservation-status.completed')
            }
        case 'pending':
            return {
                color: '#ffa600',
                name: trans('labels.reservation-status.pending')
            }
        default:
            return {
                color: '#6c757d',
                name: trans('random.unknown')
            }
    }
}
